function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "poster_svg__cls-2",
  d: "M80.41 113.03H52.12a2.791 2.791 0 010-5.58h28.29a2.791 2.791 0 010 5.58zM66.27 103.12c-14.58 0-26.44-11.86-26.44-26.44s11.86-26.44 26.44-26.44S92.71 62.1 92.71 76.68s-11.86 26.44-26.44 26.44zm0-47.89c-11.82 0-21.44 9.62-21.44 21.44s9.62 21.44 21.44 21.44 21.44-9.62 21.44-21.44-9.62-21.44-21.44-21.44z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster_svg__cls-2",
  d: "M78.23 75.72c-10.41 0-18.88-8.47-18.88-18.88s8.47-18.88 18.88-18.88 18.88 8.47 18.88 18.88-8.47 18.88-18.88 18.88zm0-32.76c-7.65 0-13.88 6.23-13.88 13.88s6.23 13.88 13.88 13.88 13.88-6.23 13.88-13.88-6.23-13.88-13.88-13.88z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster_svg__cls-2",
  d: "M105.24 122.85H27.3V28.99h77.94v93.86zm-4.89-89.35H32.19v84.84h68.16V33.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "poster_svg__cls-2",
  d: "M86.06 33.19L65.9 12.99 46.17 32.72l-3.53-3.53L65.91 5.91 89.6 29.65l-3.54 3.54z"
});

function SvgPoster(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "poster_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgPoster;